import { notification } from 'antd';

export const openPendingNotification = (txt) => {
	notification.info({
		message: '',
		placement: "bottomRight",
		duration: 5,
		description: txt,
		style: {
			display: 'flex',
			textAlign: 'center',
			alignItems: 'center',
			justifyContent: 'center'
		}
	});
}

export const openWarningNotification = (txt) => {
	notification.warning({
		message: '',
		placement: "bottomRight",
		duration: 5,
		description: txt,
		style: {
			display: 'flex',
			textAlign: 'center',
			alignItems: 'center',
			justifyContent: 'center'
		}
	});
}

export const openSuccessNotification = (txt) => {
	notification.success({
		message: '',
		placement: "bottomRight",
		duration: 5,
		description: txt,
		style: {
			display: 'flex',
			textAlign: 'center',
			alignItems: 'center',
			justifyContent: 'center'
		}
	});
}